import { get } from '../utils/PolyfillLodash'
import executeCitrus from '../actions/executeCitrus'
import { CategoryHelper } from './CategoryHelper'
import config from '../config'

const insertAtPosition = (products, index, product) => [...products.slice(0, index), product, ...products.slice(index)]

const insertProducts = (products, citrusProducts, insertionIndexes) => {
  citrusProducts.map(product => (product.attributes.relevancyRank = 1))
  return insertionIndexes.reduce((products, position, index) => {
    return insertAtPosition(products, position, citrusProducts[index])
  }, products)
}

class CitrusHelper {
  // method does not resolve duplication of products
  static mergeProducts(products, citrusProducts) {
    let insertionIndexes = []
    const adProductCount = get(citrusProducts, 'length')
    const naturalProductCount = products && products.length

    if (products === null) {
      return null
    }

    // Mobile ads
    if (this.isProdListMobileTabletValid(citrusProducts)) {
      if (naturalProductCount >= 2) {
        // If we have more than 2 natural product results, allow ads
        insertionIndexes.push(2) // Add the first ad at the 2nd spot
        insertionIndexes.push(3) // Add the first ad at the 3rd spot
      }
      return insertProducts(products, citrusProducts, insertionIndexes)
    }

    // Desktop ads
    if (naturalProductCount >= 3 && this.isProdListDesktopValid(citrusProducts)) {
      insertionIndexes = [3, 4, 5]
      return insertProducts(products, citrusProducts, insertionIndexes)
    }

    return products
  }

  static citrusCategoryProductHandler(pageType, context, categoryResponse, productResponse) {
    const { initialRenderComplete } = context.reduxStore.getState().application
    if (initialRenderComplete && productResponse && productResponse.status === config.httpStatusCodes.success) {
      const categoryType = get(categoryResponse, 'response.data[0].type')
      const categoryTree = CategoryHelper.flattenAncestors(categoryResponse.response)
      executeCitrus(context, {
        keyword: '',
        appliedFilters: get(productResponse, 'response.meta.appliedFilters'),
        appliedSorts: get(productResponse, 'response.meta.appliedSorts'),
        currentPage: get(productResponse, 'response.meta.currentPage'),
        categoryTree,
        currentCategory: {
          id: get(categoryResponse, 'response.data[0].id'),
          name: get(categoryResponse, 'response.data[0].attributes.name')
        },
        isPlp: categoryType === 'PLP' || categoryType === 'PLPPLUS',
        pageType
      })
    }
  }

  static getCitrusProducts(pageType, context, searchTerm, productResponse, categoryResponse) {
    const { initialRenderComplete } = context.reduxStore.getState().application
    let categoryTree = null
    if (categoryResponse !== undefined) {
      if (categoryResponse.response && categoryResponse.response.data) {
        categoryTree = get(categoryResponse, 'response.data')
      } else {
        categoryTree = get(categoryResponse, 'response.included')
      }
    }
    if (initialRenderComplete && productResponse && productResponse.status === config.httpStatusCodes.success) {
      executeCitrus(context, {
        keyword: searchTerm,
        appliedFilters: get(productResponse, 'response.meta.appliedFilters'),
        appliedSorts: get(productResponse, 'response.meta.appliedSorts'),
        currentPage: get(productResponse, 'response.meta.currentPage'),
        categoryTree,
        pageType
      })
    }
  }

  static isProdListDesktopValid(prodList) {
    return get(prodList, 'length') === 3
  }

  static isProdListMobileTabletValid(prodList) {
    return get(prodList, 'length') === 2
  }
}

export default CitrusHelper
